"use strict";

require("../../style/index.less");

require("./index.less");


//////////////////
// WEBPACK FOOTER
// ../~/antd/lib/carousel/style/index.js
// module id = 350
// module chunks = 1